import { createSlice } from "@reduxjs/toolkit";
import { iAddPurchaseOrderDetailState, REDUCER_NAME } from "./Types";
import { getPurchaseOrderDetail, addPruchaseOrderProduct } from "./ThunkAction";

const initialState: iAddPurchaseOrderDetailState = {
  isLoading: false,
  isSuccess: false,
  error: null,
  purchaseOrder: null,          // single created PO
  purchaseOrderDetail: null,    // optional detail view
  purchaseOrderList: []         // ✅ always keep it as array
};

const purchaseOrderSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetPurchaseOrderState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.error = null;
      state.purchaseOrder = null;
      state.purchaseOrderDetail = null;
      state.purchaseOrderList = [];
    },
  },
  extraReducers: (builder) => {
    // ✅ Add Purchase Order
    builder.addCase(addPruchaseOrderProduct.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.error = null;
    });
    builder.addCase(addPruchaseOrderProduct.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.purchaseOrder = action.payload; // single PO response
    });
    builder.addCase(addPruchaseOrderProduct.rejected, (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.error = action.payload as string;
    });

    // ✅ Get Purchase Orders
    builder.addCase(getPurchaseOrderDetail.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.error = null;
    });
    builder.addCase(getPurchaseOrderDetail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.purchaseOrderList = action.payload ?? []; // ✅ directly use payload
    });
    builder.addCase(getPurchaseOrderDetail.rejected, (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.error = action.payload as string;
    });
  },
});

export const { resetPurchaseOrderState } = purchaseOrderSlice.actions;
export default purchaseOrderSlice.reducer;
